export class BaseStore {
  /**
   * Returns the name of the store
   */
  get name(): string {
    return this.constructor.name;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/store/base/base-store.ts